import { Column, DataTable } from "@/components/data-table";
import { useFiltersReturn } from "@/components/filters";
import { Form, useForm } from "@/components/form";
import { Stack, Typography } from "@mui/material";
import { formatDate, formatNumber, formatString } from "@/shared/formats";
import { getTotalMonedaTransferencia } from "@/features/monetizacion/shared/utils";
import { CajaMovimiento } from "@/shared/types/caja-movimiento";
import { QueryResponse, QueryResult } from "@/shared/types/base";
import useGetMonedasOfTransferencia from "../hooks/use-get-monedas-of-transferencia";
import { ListPage } from "@/components/list-page";

export interface SharedViewCajaAperturaMovimientosProps {
    fetchData: QueryResult<QueryResponse<CajaMovimiento>>,
    filterData: useFiltersReturn,
    onViewCajaMovimientoClick?: (e: React.MouseEvent<HTMLLIElement>, row: CajaMovimiento) => void
}

export default function SharedViewCajaAperturaMovimientos({
    fetchData,
    filterData,
    onViewCajaMovimientoClick
}: SharedViewCajaAperturaMovimientosProps) {
    const form = useForm({
        onSubmit: ({ value }) => {
            filterData.setFilterData({ ...filterData.filterData, ...value, page: 0 })
        },
        defaultValues: {
            desde: "",
            hasta: ""
        },
        submitOnce: false,
        closeModalOnSubmit: false,
    })

    const monedas = useGetMonedasOfTransferencia(fetchData.data?.result.map(cm => cm.transferencia) || [], true);

    return <>
        <Stack direction={"row"} justifyContent={"space-between"}>
            <Stack gap={2} direction={"row"} justifyContent={"space-between"}>
                <Form form={form} gap={2} direction={"row"}>
                    <Stack maxWidth={"200px"}>
                        <Form.DatePicker name="desde" label="Desde" clearable size="small" />
                    </Stack>
                    <Stack maxWidth={"200px"}>
                        <Form.DatePicker name="hasta" label="Hasta" displayDateOffset={-1} clearable size="small" />
                    </Stack>
                    <Form.SubmitButton size="small">Filtrar</Form.SubmitButton>
                </Form>
            </Stack>
            <Stack>
                <ListPage.Header.Actions.ExportButton>
                    <ListPage.Header.Actions.ExportButton.Print />
                    <ListPage.Header.Actions.ExportButton.Csv />
                    <ListPage.Header.Actions.ExportButton.Xlsx />
                </ListPage.Header.Actions.ExportButton>
            </Stack>
        </Stack>
        <DataTable flex={1}>
            <DataTable.Content
                fit="flex"
                rows={fetchData.data?.result || []}
                loading={fetchData.isFetching}
                columns={[
                    { key: "fecha", header: "Fecha", render: row => formatDate(row.fecha, true) },
                    { key: "descripcion", header: "Descripcion", render: row => formatString(row.descripcion) },
                    ...monedas.map<Column>(m => ({
                        key: `${m.nombre}SubTotal`,
                        header: <Typography variant="inherit" color={m.hidden ? "textDisabled" : "textPrimary"}>
                            Subtotal {m.simbolo}
                        </Typography>,
                        render: (row: CajaMovimiento) => <Typography variant="inherit" color={m.hidden ? "textDisabled" : "textPrimary"}>
                            {formatNumber(getTotalMonedaTransferencia(row.transferencia, m.id))}
                        </Typography>,
                        width: "auto",
                        align: "right",
                    })),
                    {
                        key: "action", header: "Acción", width: "auto",
                        render: row => <DataTable.EntryOption>
                            <DataTable.EntryOption.ViewButton onClick={e => onViewCajaMovimientoClick && onViewCajaMovimientoClick(e, row)} />
                        </DataTable.EntryOption>
                    }
                ]}
            />
            <DataTable.Pagination filterData={filterData} queryResult={fetchData} />
        </DataTable>
    </>
}